export const transformToString = (array) => {
  const selectedVersion = array.find((version) => version.key === true);

  return selectedVersion ? String(selectedVersion.value) : "";
};
